export default __webpack_public_path__ + "0b316193218f3eb45d60cbf11078c065.png";